import { render, staticRenderFns } from "./PopupAdicionarPrazo.vue?vue&type=template&id=8cc735b2&scoped=true&"
import script from "./PopupAdicionarPrazo.vue?vue&type=script&lang=js&"
export * from "./PopupAdicionarPrazo.vue?vue&type=script&lang=js&"
import style0 from "./popup_adicionar_prazo_global.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./popup_adicionar_prazo.scss?vue&type=style&index=1&id=8cc735b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc735b2",
  null
  
)

export default component.exports